import { t } from "@lingui/macro";
import {StorageKey} from "../../../../enums/StorageKey";
import ReceivableDetails from "./ReceivableDetails";

export default {
    storageKey: StorageKey.report_aging_details_payable,
    getReportLabel: () => t`Aged Payables Detail`,
    required: [
        'date',
        'number',
        'base_coming_due_amount',
        'total',
    ],
    getColumns: ReceivableDetails.getColumns,
};
